import { FC, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hooks/useStore';
import CloseIcon from '@icons/close_icon.svg?component';
import { alertStyleTypes } from './constants';

export const CustomAlert: FC = observer(() => {
  const {
    alertStore: { type, message, hideAlert, show, timeout },
  } = useStore();

  const [timeOut, setTimeOut] = useState<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timeOut !== null) clearTimeout(timeOut);
    if (show) {
      setTimeOut(
        setTimeout(() => {
          hideAlert();
        }, timeout)
      );
    }
    return () => {
      if (timeOut !== null) clearTimeout(timeOut);
    };
  }, [open]);

  const alertBoxStyle = useMemo(() => {
    const basic =
      'absolute w-[30%] h-fit z-100 top-[20px] left-1/2 transform -translate-x-1/2 flex flex-row justify-center items-center rounded';
    return `${basic} ${alertStyleTypes[type]}`;
  }, [type]);

  return (
    // <div className={`${styles.alertBox} ${styles[type]}`}>
    <div className={alertBoxStyle}>
      {/* <p className={styles.alertMsg}>{message}</p> */}
      <p className="w-[100%] text-center text-sm whitespace-pre-line">{message}</p>
      <button
        type="button"
        className="block cursor-pointer bg-transparent border-transparent w-[10%] ml-auto"
        onClick={() => {
          hideAlert();
        }}
      >
        <CloseIcon />
      </button>
    </div>
  );
});
